import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 * Angular Component that show expiration password days remains modal and invite user to change password
 */
@Component({
  selector: 'ap-two-factor-client-expire-adv',
  templateUrl: './twofactor-client-expire-adv.modal.component.html',
})
export class TwoFactorClientExpireAdvisorModalComponent implements OnInit {
  @Input()
  label: 'nearly' | 'expired' | 'renew' = 'nearly';

  @Input()
  public expirationDate = null;

  bgClass = 'warning-bg';
  svgSrc = 'content/images/icons/alert-triangle.svg';

  constructor(public activeModal: NgbActiveModal) { }

  /**
   * Set background and icon src if label is 'expired'
   */
  ngOnInit(): void {
    if (this.label === 'expired') {
      this.bgClass = 'danger-bg';
      this.svgSrc = 'content/images/icons/octagon_deny.svg';
    }
  }
  /**
   * Close modal
   */
  hideAdvise(): void {
    this.activeModal.close();
  }
}
